import services from "@/services/product/services";

var store = {
    debug: false,
    state: {
        brandFilter: [],
        manufacturerFilter: [],
        typeFilter: [],
        products: [],
        brands: [],
        manufacturers: [],
        types: [],
        supplierPrices: [],
        nameFilter: "",
        loading: true,
        selectedProduct: null,
        adInfo: {
            id: null,
            clientName: null,
            businessName: null,
            address: null,
            phone: null,
            lineWork: null,
            website: null,
            image: null,
            fileImage: null,
            shortDescripton: null,
            approved: null
        },
        latitude: 0.000,
        longitude: 0.000
    },
    async getProducts(
        name = this.state.nameFilter,
        brands = this.state.brandFilter,
        manufacturers = this.state.manufacturerFilter,
        types = this.state.typeFilter) {
        if (!this.state.loading) this.state.loading = true;
        services
            .fetchProducts(name, brands, manufacturers, types)
            .then(products => {
                this.state.loading = false;
                this.state.products = products.data;
            });
    },
    async getBrands() {
        services.fetchProductBrands().then(brands => {
            this.state.brands = brands.data;
        });
    },
    async getManufacturers() {
        services.fetchProductManufactures().then(manufacturers => {
            this.state.manufacturers = manufacturers.data;
        });
    },
    async getTypes() {
        services.fetchProductTypes().then(types => {
            this.state.types = types.data;
        });
    },
    async getProductPrices(id) {
        if (!this.state.loading) this.state.loading = true;
        services.fetchProductPrices(id).then(prices => {
            this.state.loading = false;
            this.state.supplierPrices = prices.data;
        });
    },
    async getProduct(id) {
        services.fetchProduct(id).then(product => {
            this.state.selectedProduct = product.data;
        });
    },
    async getSpot(latitude, longitude) {
        services.fetchSpot(latitude, longitude).then(spot => {
            this.setAdInfo(spot.data.closest);
        });
    },
    setNameFilter(data) {
        this.state.nameFilter = data ? data : '';
    },
    setBrandFilter(data) {
        this.state.brandFilter = data;
    },
    setManufacturerFilter(data) {
        this.state.manufacturerFilter = data;
    },
    setTypeFilter(data) {
        this.state.typeFilter = data;
    },
    setSelectedProduct(data) {
        this.state.selectedProduct = data;
    },
    setAdInfo(data) {
        this.state.adInfo.clientName = data?.client_name;
        this.state.adInfo.businessName = data?.business_name;
        this.state.adInfo.address = data?.address;
        this.state.adInfo.shortDescription = data?.short_description;
        this.state.adInfo.phone = data?.phone_number;
        this.state.adInfo.website = data?.website;
        this.state.adInfo.image = data?.image;
        this.state.adInfo.lineWork = data?.line_of_work;
        this.state.adInfo.approved = data?.approved;
    },
    setLatitude(value) {
        this.state.latitude = value;
    },
    setLongitude(value) {
        this.state.longitude = value;
    }
}

export default store;